<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ registerTerminalHeader }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-row *ngIf="submitAttempt || registerSuccessful">
    <salonmonster-checkmark-loader
      class="center-block"
      [completed]="registerSuccessful"
    ></salonmonster-checkmark-loader>
  </ion-row>
  <ion-row *ngIf="registerSuccessful" class="ease-in">
    <p class="register-card-reader-header text-align-center">
      Your card reader has been registered. The card reader will now complete any software updates. Please wait for those to complete before you connect to it.
    </p>
    <ion-col
      *ngIf="p400Device"
      size-sm="12"
      size-md="12"
      size-lg="8"
      size-xl="8"
      class="margin-bottom-50 margin-top-20 connectedTerminalBlock center-block"
    >
      <img
        src="../../../assets/images/verifone%20p400.png"
        class="verifoneP400Image"
        alt=""
      />
      <span [ngClass]="'verifoneSpan'">Verifone P400</span>
    </ion-col>
    <ion-col size="12">
      <ion-button
        (click)="continue()"
        color="primary"
        ng-reflect-color="primary"
        class="button button-md button-default center-block button-default-md button-md-primary payment-process-button margin-top-20"
      >
        <span class="button-inner">Continue</span>
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="registerUnsuccessful" class="ease-in">
    <ion-col size="12">
      <p class="register-card-reader-header text-align-center">
        Oops, we had trouble registering your card reader, please:
      </p>
    </ion-col>
    <ion-col size="12">
      <div class="register-card-reader-unsuccessful">
        <p>1) Double check the 3-word code was entered correctly</p>
        <p>2) Make sure your card reader is connected to your local network</p>
        <p>3) Turn your card reader off, then back on</p>
      </div>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="!registerSuccessful && !submitAttempt" class="ease-in">
    <p class="register-card-reader-header text-align-center">
      <b>On your card reader please:</b><br /><br />
      1) Swipe from left to right to show the settings menu<br />
      2) Tap the Settings button and enter the admin PIN <b>07139</b><br />
      3) Tap "Generate pairing code"
    </p>
    <p class="register-card-reader-header text-align-center">
      <b>Then enter the pairing code it displays below:</b>
    </p>
    <ion-col size="12">
      <ion-input
        [(ngModel)]="terminalCode"
        type="text"
        class="card-reader-code-input"
        ngDefaultControl
      ></ion-input>
    </ion-col>
    <ion-button
      (click)="submitCode()"
      color="primary"
      ng-reflect-color="primary"
      class="button button-md button-default center-block button-default-md button-md-primary payment-process-button margin-top-20"
    >
      <span class="button-inner">Register card reader</span>
    </ion-button>
  </ion-row>
</ion-content>
